import { CarJobCategory } from "../../keep/constants/keep-basic-data";
import { CarRefItemStatus } from "../constants/car-basic-data";

export class CarJobTask {
    id: number = 0;
    
    code = '';
    title = '';
    details = '';
    category: CarJobCategory = CarJobCategory.AIR_CONDITIONING;
    status: CarRefItemStatus = CarRefItemStatus.REVIEW;
    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, title: string)  {
        this.code = code!;
        this.title = title!;
    }
  }
  